import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'mom-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() acceptText: string;
  @Input() cancelText: string;

  constructor(private modalCtrl: ModalController) {}

  onAccept(): void {
    this.modalCtrl.dismiss(null, 'confirm');
  }

  onCancel(): void {
    this.modalCtrl.dismiss(null, 'cancel');
  }
}
